module.exports = __webpack_public_path__ + "img/ic-ic-check-gray.1d69dc18.svg";